import { GridValueFormatterParams } from '@mui/x-data-grid-pro'

export const referralDiscountCodeFormatter = ({
  value,
}: GridValueFormatterParams): any => {
  if (!!value && typeof value === 'string') {
    return value
  }

  return ''
}
